export default {
  apiKey: "AIzaSyBPhuTb2o_gIiEQxrOkStXGx-CTUXSw2bA",
  authDomain: "karate-trainer79.firebaseapp.com",
  databaseURL:
    "https://karate-trainer79-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "karate-trainer79",
  storageBucket: "karate-trainer79.appspot.com",
  messagingSenderId: "182237694501",
  appId: "1:182237694501:web:f17d678d4e4abbd8ce0dcc",
  measurementId: "G-L9BE5DCY86",
};
